/**
 * What is selected on the page right now, so the palette can rank and offer actions on it
 * ("Stop 3 selected sessions"). Lists publish their selection here while they are mounted.
 */
import { useEffect } from 'react';
import { create } from 'zustand';

export interface PageSelection {
  kind: 'sessions' | null;
  ids: string[];
}

export const usePageSelection = create<PageSelection>()(() => ({ kind: null, ids: [] }));

/** Publish a list's selection while the component is mounted. */
export function usePublishSelection(kind: 'sessions', ids: readonly string[]): void {
  const key = ids.join(',');
  useEffect(() => {
    usePageSelection.setState({ kind: ids.length ? kind : null, ids: [...ids] });
    // key stands for ids.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind, key]);
  useEffect(() => () => usePageSelection.setState({ kind: null, ids: [] }), []);
}
